var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.561,
    height: 30.24,
    viewBox: "0 0 26.561 30.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-svgrepo-com",
    transform: "translate(-19.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M37.628,0H19.7V30.24H46.26V7.814Zm4.183,7.124h-3.42v-3.1ZM22.3,27.881V2.359h13.48V8.3a1.246,1.246,0,0,0,1.3,1.179h6.566v18.4Z",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 15.843,
    height: 1.602,
    transform: "translate(25.058 23.409)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 8.182,
    height: 1.602,
    transform: "translate(25.735 8.657)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M64.314,78.537h1.012L61.415,81.97l-3.058-2.684L51.6,85.22l1.291,1.133,5.469-4.8,3.058,2.684,5.2-4.565v.886h1.826V76.935H64.314Z",
    transform: "translate(-26.786 -64.937)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 8.182,
    height: 1.602,
    transform: "translate(25.735 5.229)",
    fill: "#007cab"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReBlue);
export default __webpack_public_path__ + "static/media/RE_Blue.82939c9385adb0d8f65ee52384bee660.svg";
export { ForwardRef as ReactComponent };